import React, { useEffect, useState, useRef } from "react";
import { Button } from "primereact/button";
import { RadioButton } from "primereact/radiobutton";
import { InputTextarea } from "primereact/inputtextarea";
import { SelectButton } from "primereact/selectbutton";
export default function Panel_F({ data, setData, onUploadDialog, uploadPic, disabledPage }) {
    useEffect(() => {
        // console.log('data ',data);
    }, [data]); //searchData

    const onInputTextChange = (e, key) => {
        const val = (e.target && e.target.value) || "";
        setData({
            ...data,
            [`${key}`]: val,
        });
    };
    const display_mode = () => {
        return data.displayMode === "Y" ? true : false;
    };

    const chlorineCleaningResultOptions = [
        { label: "ผ่าน", value: "Y" },
        { label: "แก้ไข", value: "N" },

    ];

    const pressureTesingResultOptions = [
        { label: "ถูกต้อง", value: "Y" },
        { label: "แก้ไข", value: "N" },

    ];
    return (
        <div>
            <div className="p-grid  p-fluid">
                <div className="p-col-12 p-md-12">
                    <h5>
                        <b className="p-no-box line-under">การตรวจสอบระบบท่อประปา</b> ปริมาณงาน
                    </h5>
                </div>
                <div className="p-col-12 p-md-6">
                    <div className="p-grid p-fluid">
                        <div className="p-col-12 p-md-5">
                            <label htmlFor="p-field-radiobutton">- ล้างทำความสะอาด(คอลรีนไว้ 24 ชม.)</label>
                        </div>
                        <div className="p-col-12 p-md-5">
                            <div className="p-grid">
                                <div className="p-col-12 p-md-12">
                                <div className="flex justify-content-center">
                                        <SelectButton
                                            id="chlorineCleaningResult"
                                            optionLabel="label"
                                            options={chlorineCleaningResultOptions}
                                            value={data.chlorineCleaningResult}
                                            onChange={(e) => onInputTextChange(e, "chlorineCleaningResult")}
                                            optionValue="value"
                                            disabled={disabledPage}

                                        />
                                    </div>
                                    {/* <div className="p-field-radiobutton">
                                        <RadioButton
                                            inputId="chlorineCleaningResult_1"
                                            name="chlorineCleaningResult"
                                            id="chlorineCleaningResult_1"
                                            value="Y"
                                            key="chlorineCleaningResult_1"
                                            checked={data.chlorineCleaningResult === "Y" ? true : false}
                                            onChange={(e) => onInputTextChange(e, "chlorineCleaningResult")}
                                            disabled={disabledPage}
                                        />
                                        <label htmlFor="chlorineCleaningResult_1">ผ่าน</label>
                                    </div> */}
                                </div>
                                {/* <div className="p-col-12 p-md-6">
                                    <div className="p-field-radiobutton">
                                        <RadioButton
                                            inputId="chlorineCleaningResult_2"
                                            name="chlorineCleaningResult"
                                            id="chlorineCleaningResult_2"
                                            value="N"
                                            key="chlorineCleaningResult_2"
                                            checked={data.chlorineCleaningResult === "N" ? true : false}
                                            onChange={(e) => onInputTextChange(e, "chlorineCleaningResult")}
                                            disabled={disabledPage}
                                        />
                                        <label htmlFor="chlorineCleaningResult_2">แก้ไข</label>
                                    </div>
                                </div> */}
                            </div>
                        </div>

                        <div className="p-col-12 p-md-2">
                            {data.chlorineCleaningResult !== undefined && data.chlorineCleaningResult !== "0" && !display_mode() ? (
                                <img title="อัปโหลดรูป" alt="อัปโหลดรูป" src="assets/layout/images/Upload_a_picture.png" style={{ width: 35, height: 35 }} onClick={() => uploadPic("T601")} />
                            ) : (
                                <img title="อัปโหลดรูป" alt="อัปโหลดรูป" src="assets/layout/images/Upload_a_picture.png" style={{ width: 35, height: 35 }} />
                            )}
                            {data.chlorineCleaningResult !== undefined && data.chlorineCleaningResult !== "0" ? (
                                <img title="รูป" alt="รูป" src="assets/layout/images/gallery.png" style={{ width: 35, height: 35 }} onClick={() => onUploadDialog("T601")} />
                            ) : (
                                <img title="รูป" alt="รูป" src="assets/layout/images/gallery.png" style={{ width: 35, height: 35 }} />
                            )}

                            {/* <Button className="p-button-info p-button p-md-12 " icon="pi pi-image" label="รูปถ่าย" onClick={() => onUploadDialog("T601")} /> */}
                        </div>
                    </div>

                    <div className="p-grid p-fluid">
                        <div className="p-col-12 p-md-5">
                            <label htmlFor="p-field-radiobutton">- แรงดัน 6 กก./ตร.ม.(3 ชม.)</label>
                        </div>
                        <div className="p-col-12 p-md-5">
                            <div className="p-grid">
                                <div className="p-col-12 p-md-12">
                                <div className="flex justify-content-center">
                                        <SelectButton
                                            id="pressureTesingResult"
                                            optionLabel="label"
                                            options={pressureTesingResultOptions}
                                            value={data.pressureTesingResult}
                                            onChange={(e) => onInputTextChange(e, "pressureTesingResult")}
                                            optionValue="value"
                                            disabled={disabledPage}

                                        />
                                    </div>
                                    {/* <div className="p-field-radiobutton">
                                        <RadioButton
                                            inputId="pressureTesingResult_1"
                                            name="pressureTesingResult"
                                            id="pressureTesingResult_1"
                                            value="Y"
                                            key="pressureTesingResult_1"
                                            checked={data.pressureTesingResult === "Y" ? true : false}
                                            onChange={(e) => onInputTextChange(e, "pressureTesingResult")}
                                            disabled={disabledPage}
                                        />
                                        <label htmlFor="pressureTesingResult_1">ถูกต้อง</label>
                                    </div> */}
                                </div>
                                {/* <div className="p-col-12 p-md-6">
                                    <div className="p-field-radiobutton">
                                        <RadioButton
                                            inputId="pressureTesingResult_2"
                                            name="pressureTesingResult"
                                            id="pressureTesingResult_2"
                                            value="N"
                                            key="pressureTesingResult_2"
                                            checked={data.pressureTesingResult === "N" ? true : false}
                                            onChange={(e) => onInputTextChange(e, "pressureTesingResult")}
                                            disabled={disabledPage}
                                        />
                                        <label htmlFor="pressureTesingResult_2">แก้ไข</label>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                        <div className="p-col-12 p-md-2">
                            {data.pressureTesingResult !== undefined && data.pressureTesingResult !== "0" && !display_mode() ? (
                                <img title="อัปโหลดรูป" alt="อัปโหลดรูป" src="assets/layout/images/Upload_a_picture.png" style={{ width: 35, height: 35 }} onClick={() => uploadPic("T602")} />
                            ) : (
                                <img title="อัปโหลดรูป" alt="อัปโหลดรูป" src="assets/layout/images/Upload_a_picture.png" style={{ width: 35, height: 35 }} />
                            )}
                            {data.pressureTesingResult !== undefined && data.pressureTesingResult !== "0" ? (
                                <img title="รูป" alt="รูป" src="assets/layout/images/gallery.png" style={{ width: 35, height: 35 }} onClick={() => onUploadDialog("T602")} />
                            ) : (
                                <img title="รูป" alt="รูป" src="assets/layout/images/gallery.png" style={{ width: 35, height: 35 }} />
                            )}

                            {/* <Button className="p-button-info p-button p-md-12 " icon="pi pi-image" label="รูปถ่าย" onClick={() => onUploadDialog("T602")} /> */}
                        </div>
                    </div>
                </div>

                <div className="p-col-12 p-md-6">
                    <div className="p-grid p-fluid">
                        <div className="p-col-12 p-md-1"></div>
                        <div className="p-col-12 p-md-1">
                            <label htmlFor="p-field-radiobutton">บันทึก</label>
                        </div>
                        <div className="p-col-12 p-md-9">
                            <div className="p-inputgroup">
                                <InputTextarea disabled={disabledPage} value={data.inspectNote} rows={5} cols={30} autoResize maxLength="5000" onChange={(e) => onInputTextChange(e, "inspectNote")} />
                            </div>
                        </div>
                        <div className="p-col-12 p-md-1"></div>
                    </div>
                </div>
            </div>
        </div>
    );
}
